<script lang="ts">
	import type { GeneratedPointCloud } from '$lib/diffusionApi';
	import { analytics } from '$lib/analytics';

	export let generatedPointClouds: GeneratedPointCloud[];
	export let display3dIndex: number | undefined;
	export let display3d: GeneratedPointCloud | undefined;

	export let index: number;
	export let pointCloud: GeneratedPointCloud;

	export let assetSelectionIds: string[];
	export let clickAssetAction: 'view' | 'select';
	export let pointCloudGenerationIdToImage: { [generationId: string]: HTMLImageElement } = {};
	export let showSelectionBoxes: boolean;
	export let open3dModal: () => void;

	const handleAction = () => {
		if (clickAssetAction === 'view') {
			analytics.capture('view_generated_3d', {
				generation_id: pointCloud.generation_id
			});
			display3dIndex = index;
			display3d = pointCloud;
			open3dModal();
		} else if (clickAssetAction === 'select') {
			if (assetSelectionIds.includes(pointCloud.generation_id)) {
				assetSelectionIds = assetSelectionIds.filter((_) => _ !== pointCloud.generation_id);
			} else {
				assetSelectionIds = [...assetSelectionIds, pointCloud.generation_id];
			}
		}
	};
</script>

<div
	class={`group w-44 aspect-w-1 aspect-h-1 block overflow-hidden
	bg-primary-300 dark:bg-navy-900
	hover:opacity-75 ${index === generatedPointClouds.length - 1 ? `load-more` : ''}`}
>
	{#if pointCloudGenerationIdToImage[pointCloud.generation_id]}
		<img
			src={pointCloudGenerationIdToImage[pointCloud.generation_id].src}
			alt={`${index}`}
			class="pointer-events-none object-cover"
		/>
	{/if}
	<div
		class={`absolute w-full h-full ${assetSelectionIds.includes(pointCloud.generation_id) ? 'bg-cyan-400 opacity-15' : ''}`}
	></div>
	<div
		role="button"
		tabindex="0"
		class={`absolute inset-0 focus:outline-none library-image-button ${assetSelectionIds.includes(pointCloud.generation_id) ? 'shadow-[inset_0_0_0_2px_#22D3EE]' : ''}`}
		on:click={() => handleAction()}
		on:keydown={(e) => {
			if (e.key === 'Enter') {
				handleAction();
			}
		}}
	>
		{#if showSelectionBoxes}
			<button
				aria-label="Select 3D model"
				class={`absolute bottom-1 left-1 w-10 h-10 rounded
					bg-primary-50 text-primary-50 hover:text-primary-200 hover:brightness-90
					dark:bg-navy-900 dark:text-navy-900 dark:hover:text-zinc-800 dark:hover:brightness-150
            		${!assetSelectionIds.includes(pointCloud.generation_id) ? 'pin-controls border border-primary-200 dark:border-zinc-800' : 'border-2 border-cyan-400'}`}
				on:click={(e) => {
					e.stopPropagation();
					if (assetSelectionIds.includes(pointCloud.generation_id)) {
						assetSelectionIds = assetSelectionIds.filter((_) => _ !== pointCloud.generation_id);
					} else {
						assetSelectionIds = [...assetSelectionIds, pointCloud.generation_id];
					}
				}}
			>
				{#if assetSelectionIds.includes(pointCloud.generation_id)}
					<i class="fa-solid fa-check text-cyan-400"></i>
				{:else}
					<i class="fa-solid fa-check"></i>
				{/if}
			</button>
		{/if}
	</div>
</div>
